module.exports = __webpack_public_path__ + "img/MILFormula3.3c393e4f.png";